export const colorSelect2 = (status) => {
    if (status==="closed") return "green"
    else if (status==="open") return "red"
}